/**
 * 原始数据Mock API
 */

// 生成原始数据样本 - 根据不同的数据类型生成不同的表头结构
const generateRawDataSample = (id) => {
  const dataTypes = ['pure_sales', 'delivery', 'inventory'];
  const selectedType = dataTypes[parseInt(id) % 3];
  
  switch (selectedType) {
    case 'pure_sales':
      return generatePureSalesData();
    case 'delivery':
      return generateDeliveryData();
    case 'inventory':
      return generateInventoryData();
    default:
      return generatePureSalesData();
  }
};

// 生成纯销数据
const generatePureSalesData = () => {
  const regions = ['华东区', '华北区', '华南区', '西南区', '东北区'];
  const chains = ['国大药房', '老百姓大药房', '一心堂', '大参林', '华润万家'];
  const products = ['感冒灵颗粒', '布洛芬片', '阿莫西林胶囊', '维生素C片', '板蓝根颗粒'];
  const provinces = ['上海', '北京', '广东', '四川', '辽宁'];
  const cities = ['上海市', '北京市', '广州市', '成都市', '沈阳市'];
  
  const result = [];
  for (let i = 0; i < 20; i++) {
    result.push({
      '商务大区': regions[Math.floor(Math.random() * regions.length)],
      '连锁名称': chains[Math.floor(Math.random() * chains.length)],
      '产品名称': products[Math.floor(Math.random() * products.length)],
      '规格': ['10g*10袋', '500mg*12片', '0.25g*24粒'][Math.floor(Math.random() * 3)],
      '单位': '盒',
      '销售数量': Math.floor(Math.random() * 500) + 50,
      '批号': `BH2023${String(Math.floor(Math.random() * 1000)).padStart(4, '0')}`,
      '销售日期': `2023-11-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      '销售价格': (Math.random() * 50 + 10).toFixed(2),
      '客户名称': `药店${Math.floor(Math.random() * 999) + 1}`,
      '省份': provinces[Math.floor(Math.random() * provinces.length)],
      '城市': cities[Math.floor(Math.random() * cities.length)],
      '区县': ['浦东新区', '朝阳区', '天河区', '锦江区', '和平区'][Math.floor(Math.random() * 5)]
    });
  }
  return result;
};

// 生成配送数据
const generateDeliveryData = () => {
  const distributors = ['华润医药', '国药控股', '上药集团', '九州通', '华邦健康'];
  const products = ['感冒灵颗粒', '布洛芬片', '阿莫西林胶囊', '维生素C片', '板蓝根颗粒'];
  
  const result = [];
  for (let i = 0; i < 15; i++) {
    result.push({
      '配送商': distributors[Math.floor(Math.random() * distributors.length)],
      '产品名称': products[Math.floor(Math.random() * products.length)],
      '规格': ['10g*10袋', '500mg*12片', '0.25g*24粒'][Math.floor(Math.random() * 3)],
      '配送数量': Math.floor(Math.random() * 2000) + 200,
      '配送单价': (Math.random() * 30 + 5).toFixed(2),
      '配送日期': `2023-11-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      '目标客户': `连锁药店${Math.floor(Math.random() * 99) + 1}`,
      '配送地区': ['华东', '华北', '华南', '西南'][Math.floor(Math.random() * 4)],
      '运输方式': ['陆运', '空运', '海运'][Math.floor(Math.random() * 3)],
      '批次号': `PH2023${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`,
      '有效期': `2025-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`
    });
  }
  return result;
};

// 生成库存数据
const generateInventoryData = () => {
  const warehouses = ['上海仓库', '北京仓库', '广州仓库', '成都仓库', '沈阳仓库'];
  const products = ['感冒灵颗粒', '布洛芬片', '阿莫西林胶囊', '维生素C片', '板蓝根颗粒'];
  
  const result = [];
  for (let i = 0; i < 12; i++) {
    result.push({
      '仓库名称': warehouses[Math.floor(Math.random() * warehouses.length)],
      '产品名称': products[Math.floor(Math.random() * products.length)],
      '规格': ['10g*10袋', '500mg*12片', '0.25g*24粒'][Math.floor(Math.random() * 3)],
      '当前库存': Math.floor(Math.random() * 5000) + 500,
      '安全库存': Math.floor(Math.random() * 1000) + 100,
      '单位成本': (Math.random() * 20 + 3).toFixed(2),
      '入库日期': `2023-${String(Math.floor(Math.random() * 2) + 10).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      '有效期': `2025-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      '批次号': `KC2023${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`,
      '供应商': ['供应商A', '供应商B', '供应商C'][Math.floor(Math.random() * 3)],
      '库存状态': ['正常', '预警', '紧急'][Math.floor(Math.random() * 3)]
    });
  }
  return result;
};

const rawDataRoutes = [
  {
    url: '/api/raw-data/list',
    method: 'get',
    response: ({ query }) => {
      const { page = 1, pageSize = 10, dataType, status } = query;
      
      // 生成模拟数据
      const generateMockData = (count) => {
        const result = [];
        
        const dataTypes = ['pure_sales', 'delivery', 'inventory'];
        const statuses = ['pending', 'processing', 'completed', 'failed'];
        
        for (let i = 0; i < count; i++) {
          const mockDataType = dataType || dataTypes[Math.floor(Math.random() * dataTypes.length)];
          const mockStatus = status || statuses[Math.floor(Math.random() * statuses.length)];
          
          // 生成进度和时间信息
          let progress = 0;
          let startTime = null;
          let estimatedEndTime = null;
          let currentStep = null;
          let errorMessage = null;
          
          switch (mockStatus) {
            case 'processing':
              progress = Math.floor(Math.random() * 80) + 10; // 10-90%
              startTime = `2023-11-${15 + (i % 15)} ${10 + (i % 10)}:${Math.floor(Math.random() * 60)}:00`;
              estimatedEndTime = `2023-11-${15 + (i % 15)} ${12 + (i % 10)}:${Math.floor(Math.random() * 60)}:00`;
              currentStep = ['数据清洗', '格式转换', '质量检查', '数据验证'][Math.floor(Math.random() * 4)];
              break;
            case 'completed':
              progress = 100;
              startTime = `2023-11-${15 + (i % 15)} ${10 + (i % 10)}:${Math.floor(Math.random() * 60)}:00`;
              estimatedEndTime = `2023-11-${15 + (i % 15)} ${11 + (i % 10)}:${Math.floor(Math.random() * 60)}:00`;
              break;
            case 'failed':
              progress = Math.floor(Math.random() * 50) + 10; // 失败时的进度
              startTime = `2023-11-${15 + (i % 15)} ${10 + (i % 10)}:${Math.floor(Math.random() * 60)}:00`;
              errorMessage = ['数据格式错误', '网络连接超时', '字段映射失败', '数据验证失败'][Math.floor(Math.random() * 4)];
              break;
          }
          
          result.push({
            id: `${i + 1}`,
            sourceName: `${['华东区', '华北区', '华南区', '西南区'][Math.floor(Math.random() * 4)]}药店流向数据${20231115 + i}`,
            dataType: mockDataType,
            status: mockStatus,
            recordCount: Math.floor(Math.random() * 1000) + 100,
            collectionTime: `2023-11-${15 + (i % 15)} ${10 + (i % 10)}:${30 + (i % 30)}:00`,
            progress,
            startTime,
            estimatedEndTime,
            currentStep,
            errorMessage,
            collector: ['系统管理员', '数据分析师', '业务专员'][Math.floor(Math.random() * 3)],
            sourceType: ['website', 'file', 'api'][Math.floor(Math.random() * 3)]
          });
        }
        
        return result;
      };
      
      const list = generateMockData(100);
      
      // 根据查询参数过滤
      let filteredList = list;
      
      if (dataType) {
        filteredList = filteredList.filter(item => item.dataType === dataType);
      }
      
      if (status) {
        filteredList = filteredList.filter(item => item.status === status);
      }
      
      // 分页
      const startIndex = (page - 1) * pageSize;
      const endIndex = startIndex + Number(pageSize);
      const pagedList = filteredList.slice(startIndex, endIndex);
      
      return {
        code: 200,
        message: '获取原始数据列表成功',
        data: {
          list: pagedList,
          total: filteredList.length,
          page: Number(page),
          pageSize: Number(pageSize)
        }
      };
    }
  },
  
  {
    url: '/api/raw-data/detail/:id',
    method: 'get',
    response: (req) => {
      const id = req.params?.id || req.url?.split('/').pop();
      
      return {
        code: 200,
        message: '获取原始数据详情成功',
        data: {
          info: {
            id,
            sourceName: `药店流向数据${id}`,
            dataType: 'pure_sales',
            status: 'pending',
            recordCount: 256,
            collectionTime: '2023-11-15 10:30:00',
            creator: '系统管理员',
            createTime: '2023-11-15 10:30:00',
            updateTime: '2023-11-15 10:30:00',
            remarks: '每日常规数据导入',
            sourceType: 'file',
            collector: '系统管理员'
          },
          rawData: generateRawDataSample(id)
        }
      };
    }
  },
  
  {
    url: '/api/raw-data/add',
    method: 'post',
    response: () => {
      return {
        code: 200,
        message: '添加原始数据成功',
        data: {
          id: `${Date.now()}`
        }
      };
    }
  },
  
  {
    url: '/api/raw-data/import',
    method: 'post',
    response: ({ body }) => {
      console.log('文件导入请求:', body);
      
      // 模拟文件处理逻辑
      const totalCount = Math.floor(Math.random() * 1000) + 100;
      const invalidCount = Math.floor(Math.random() * 50);
      const validCount = totalCount - invalidCount;
      
      // 模拟随机成功/失败
      const isSuccess = Math.random() > 0.1; // 90% 成功率
      
      if (!isSuccess) {
        return {
          code: 400,
          message: '文件导入失败：文件格式不正确或数据存在严重错误',
          data: null
        };
      }
      
      return {
        code: 200,
        message: '文件导入成功',
        data: {
          id: `import-${Date.now()}`,
          totalCount,
          validCount,
          invalidCount,
          processTime: '2.5秒',
          importTime: new Date().toISOString()
        }
      };
    }
  },
  
  {
    url: '/api/raw-data/delete',
    method: 'post',
    response: () => {
      return {
        code: 200,
        message: '删除原始数据成功',
        data: null
      };
    }
  },
  
  {
    url: '/api/raw-data/progress/:id',
    method: 'get',
    response: (req) => {
      const id = req.params?.id || req.url?.split('/').pop();
      
      return {
        code: 200,
        message: '获取处理进度成功',
        data: {
          id,
          progress: Math.floor(Math.random() * 100),
          status: ['processing', 'completed', 'failed'][Math.floor(Math.random() * 3)],
          currentStep: '数据清洗中...',
          startTime: '2023-11-15 10:30:00',
          estimatedEndTime: '2023-11-15 12:00:00',
          processedRecords: Math.floor(Math.random() * 500) + 100,
          totalRecords: 500,
          errorCount: Math.floor(Math.random() * 10),
          logs: [
            { time: '2023-11-15 10:30:00', level: 'INFO', message: '开始数据处理' },
            { time: '2023-11-15 10:35:00', level: 'INFO', message: '数据验证完成' },
            { time: '2023-11-15 10:40:00', level: 'WARNING', message: '发现3条异常数据' },
            { time: '2023-11-15 10:45:00', level: 'INFO', message: '数据清洗进行中...' }
          ]
        }
      };
    }
  }
];

module.exports = rawDataRoutes; 